/**
 * Toast Notification Utility
 *
 * Provides a centralized interface for showing user notifications.
 * Currently uses browser's native support or can be extended with a toast library.
 */

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastOptions {
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

interface Toast {
  success: (message: string, options?: ToastOptions) => void;
  error: (message: string, options?: ToastOptions) => void;
  warning: (message: string, options?: ToastOptions) => void;
  info: (message: string, options?: ToastOptions) => void;
}

/**
 * Simple toast implementation using browser alerts.
 * Can be replaced with react-hot-toast, sonner, or other toast library.
 *
 * Usage:
 * ```typescript
 * import { toast } from '../utils/toast';
 *
 * toast.success('Operation completed');
 * toast.error('Something went wrong', { duration: 5000 });
 * toast.warning('Are you sure?');
 * toast.info('Loading data...');
 * ```
 */
export const toast: Toast = {
  success: (message) => {
    console.info(`[SUCCESS] ${message}`);
    // TODO: Integrate with actual toast library (react-hot-toast, sonner, etc.)
    // hotToast.success(message, { duration: 3000 });
  },

  error: (message) => {
    console.error(`[ERROR TOAST] ${message}`);
    // TODO: Integrate with actual toast library
    // hotToast.error(message, { duration: 5000 });
  },

  warning: (message) => {
    console.warn(`[WARNING] ${message}`);
    // TODO: Integrate with actual toast library
    // hotToast(message, { icon: '⚠️', duration: 4000 });
  },

  info: (message) => {
    console.info(`[INFO] ${message}`);
    // TODO: Integrate with actual toast library
    // hotToast(message, { icon: 'ℹ️', duration: 3000 });
  },
};

export default toast;
